export interface LegacyReservationActionTarget {
  isReserved?: boolean
  smartOrderKey?: string | null
  smartReservationId?: number | null
}

export function isSmartOmsReservation(value: LegacyReservationActionTarget) {
  if (value.isReserved === false) return false
  return value.smartReservationId != null || Boolean(value.smartOrderKey?.trim())
}

export function canUseLegacyReservationActions(value: LegacyReservationActionTarget) {
  return !isSmartOmsReservation(value)
}
